var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { core, elements } from "../../../charts/";
import { BallenbakSimulation } from "../../shared/ballenbak.simulation";
import { breakpoints } from '@local/styleguide';
const graphHeight = window.innerWidth < breakpoints.sm ? 320 : 520;
// can this be a wrapper for multiple graphcontrollers?
export class RevenueCirclesV1 extends core.GraphControllerV3 {
    constructor(slug, page, group, mapping, segment, index) {
        super(slug, page, group, mapping, segment);
        this.slug = slug;
        this.page = page;
        this.group = group;
        this.mapping = mapping;
        this.segment = segment;
        this.index = index;
        this.pre();
    }
    pre() {
        const bottom = window.innerWidth < breakpoints.sm ? 30 : 90;
        this._addMargin(120, bottom, 0, 0);
        this._addPadding(0, 0, 0, 0);
        this._addScale('r', 'log', 'radius', 'value');
    }
    html() {
        if (this.group.element == null)
            return;
        this.graphEl = super._html();
        if (this.graphEl == null)
            return;
        this.graphEl.style.height = (window.innerWidth < breakpoints.sm)
            ? graphHeight.toString() + "px"
            : graphHeight.toString() + "px";
    }
    init() {
        const _super = Object.create(null, {
            _init: { get: () => super._init },
            _svg: { get: () => super._svg }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.config.minRadius = 32;
            this.config.radiusFactor = window.innerWidth < breakpoints.sm ? 1 : .6;
            yield _super._init.call(this);
            if (this.graphEl != null)
                yield _super._svg.call(this, this.graphEl);
            this.circles = new elements.ChartCircles(this);
            this.simulation = new BallenbakSimulation(this);
            yield this.update(this.group.data, this.segment, false);
            return;
        });
    }
    prepareData(data) {
        return data;
    }
    draw(data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.scales.r.set(data.graph.map(l => l.value));
            this.circles.draw(data.graph);
            this.simulation.supply(data.graph, "circles");
        });
    }
    redraw(data, range) {
        const _super = Object.create(null, {
            redraw: { get: () => super.redraw }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.redraw.call(this, data.graph);
            this.circles.redraw(this.dimensions);
            this.simulation.redraw();
        });
    }
    update(data, segment, update, range) {
        const _super = Object.create(null, {
            _update: { get: () => super._update }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super._update.call(this, this.group.data, segment, update, range);
        });
    }
}
